export class DocumentUtils {

    static getDocumentName = (document) => {
        if ( !document ) return '';

        const {
            name,
            worker,
            machine,
            document_type,
        } = document;

        const documentName = name || '';

        if ( worker ) {
            return documentName + ' ' + worker.name + ' ' + worker.last_name;
        } else if ( machine ) {
            let docName = documentName;
            if ( docName.indexOf(machine.name) < 0 ) {
                docName += ' ';
                docName += machine.name;
            }
            if ( docName.indexOf(machine.brand) < 0 ) {
                docName += ' ';
                docName += machine.brand;
            }
            if ( docName.indexOf(machine.model) < 0 ) {
                docName += ' ';
                docName += machine.model;
            }
            return docName;
        } else {
            return documentName + ' ' + (
                document_type &&
                document_type.name !== documentName &&
                documentName.indexOf(document_type.name) < 0
                    ? document_type.name
                    : ''
            );
        }
    };

}





// WEBPACK FOOTER //
// ./src/app/shared/utils/DocumentUtils.js